import {GET_CURRENT_REQUEST} from "../../../enums/Request/request.types";

export const getCurrentRequestAction = (request) => {
    return {
        type: GET_CURRENT_REQUEST,
        payload: request,
    };
};
